import { mergeTemplate } from './base-template';

export const restaurantTemplate = mergeTemplate({
  name: 'Restaurant',
  icon: '🍷',
  settings: {
    primaryColor: '#881337',
    accentColor: '#fbbf24',
    fontStack: 'serif',
    stylePreset: 'editorial',
    designDensity: 'airy',
    pageAngebot: {
      heroTitle: 'Unsere Angebote',
      heroSubtitle: 'Genuss für jeden Anlass',
      packages: [
        { name: 'Mittagsmenü', price: 'ab CHF 22', description: 'Täglich frisch, saisonal und regional', features: '2-Gang-Menü, Tagessuppe, Hauptgang, saisonale Zutaten', highlighted: false },
        { name: 'Abendkarte', price: 'à la carte', description: 'Kreative Küche mit lokalen Produkten', features: 'Vorspeisen, Hauptgänge, Desserts, Vegetarische Optionen, Weinbegleitung', highlighted: true },
        { name: 'Events & Catering', price: 'auf Anfrage', description: 'Private Feiern und Firmenanlässe', features: 'Bankette bis 80 Personen, Apéro, Menüplanung, Service, Dekoration', highlighted: false },
      ],
      ctaTitle: 'Reservieren Sie Ihren Tisch',
      ctaText: 'Ob Mittagessen, Abendessen oder Firmenanlass — wir freuen uns auf Sie.',
      ctaButtonText: 'Tisch reservieren',
    },
    pageMethoden: {
      heroTitle: 'Unsere Küche',
      heroSubtitle: 'Philosophie, Herkunft und Handwerk',
      introText: 'Was auf den Teller kommt, hat Geschichte. Wir setzen auf Saisonalität, regionale Produzenten und ehrliches Handwerk.',
      steps: [
        { title: 'Saisonale Auswahl', description: 'Wir kochen mit dem, was die Saison bietet — frisch vom Markt' },
        { title: 'Regionale Lieferanten', description: 'Fleisch, Gemüse und Milchprodukte von lokalen Bauernhöfen' },
        { title: 'Handwerkliche Zubereitung', description: 'Kochen aus Überzeugung — ohne Fertigprodukte, ohne Kompromisse' },
        { title: 'Mit Liebe serviert', description: 'Aufmerksamer Service in entspannter Atmosphäre' },
      ],
      tools: [
        { name: 'Regionale Produzenten', description: 'Direkter Bezug von lokalen Bauern und Metzgern' },
        { name: 'Saisonkalender', description: 'Menüplanung nach Verfügbarkeit und Frische' },
        { name: 'Hauseigene Rezepturen', description: 'Überlieferte und moderne Rezepte' },
      ],
      philosophyTitle: 'Unser Credo',
      philosophyText: 'Gutes Essen braucht gute Zutaten, Zeit und Respekt. Wir kochen, wie wir selbst essen möchten.',
    },
    pageUeberMich: {
      heroTitle: 'Unser Team',
      heroSubtitle: 'Leidenschaft auf und hinter der Bühne',
      introText: 'Hinter jedem guten Restaurant steht ein eingespieltes Team. Lernen Sie die Menschen kennen, die Ihren Abend besonders machen.',
      imageUrl: '',
      timeline: [
        { year: '2010', text: 'Eröffnung des Restaurants' },
        { year: '2016', text: 'Auszeichnung durch GaultMillau' },
        { year: '2023', text: 'Erweiterung um Eventbereich' },
      ],
      values: [
        { title: 'Frische', description: 'Täglich frisch eingekauft, saisonal und regional' },
        { title: 'Gastfreundschaft', description: 'Jeder Gast verdient eine besondere Erfahrung' },
        { title: 'Nachhaltigkeit', description: 'Verantwortungsvoller Umgang mit Ressourcen und Lebensmitteln' },
      ],
      certifications: 'GaultMillau 13 Punkte, Bio Suisse Partner',
    },
  },
  components: {
    header: {
      companyName: 'Restaurant Muster',
      logoText: 'RM',
      navItems: ['Speisekarte', 'Konzept', 'Team', 'Kontakt'],
      ctaText: 'Tisch reservieren',
    },
    hero: {
      title: 'Genuss mit Charakter',
      subtitle: 'Saisonale Küche, gute Weine, klare Handschrift.',
      primaryBtn: 'Reservieren',
      secondaryBtn: 'Menü',
    },
    trust: {
      items: [
        { value: 'Saisonal', label: 'Küche' },
        { value: 'Regional', label: 'Produkte' },
        { value: 'Wein', label: 'Selektion' },
        { value: 'Ambiente', label: 'Erlebnis' },
      ],
    },
    services: {
      title: 'Highlights',
      subtitle: '',
      items: [
        {
          icon: '🍽️',
          title: 'Menü',
          text: 'Saisonale Klassiker und Signature Dishes.',
        },
        {
          icon: '🍷',
          title: 'Weine',
          text: 'Kuratiert – passend zum Menü.',
        },
        {
          icon: '🎉',
          title: 'Anlässe',
          text: 'Private und Business Events nach Absprache.',
        },
      ],
    },
    team: {
      title: 'Unser Team',
      subtitle: 'Leidenschaft für Genuss.',
      members: [
        {
          name: 'Marco Rossi',
          role: 'Küchenchef & Inhaber',
          image: '',
          bio: 'Ausgebildet in Zürich und Lyon. Leidenschaft für saisonale Schweizer Küche.',
        },
        {
          name: 'Nina Keller',
          role: 'Restaurantleiterin & Sommelière',
          image: '',
          bio: 'Verantwortlich für Service, Weinkarte und Eventplanung.',
        },
      ],
    },
    testimonials: {
      title: 'Gästestimmen',
      items: [
        {
          quote: 'Wunderbares Menü und sehr aufmerksamer Service.',
          author: 'Gast',
          role: '',
        },
        {
          quote: 'Das beste Mittagsmenü in der Region — frisch, kreativ und zu einem fairen Preis.',
          author: 'Lukas B.',
          role: 'Stammgast',
        },
        {
          quote: 'Unseren Firmenanlass hier durchgeführt. Perfekte Organisation und hervorragendes Essen.',
          author: 'Sandra W.',
          role: 'Geschäftsführerin',
        },
        {
          quote: 'Die Weinbegleitung war ein Erlebnis. Jeder Gang perfekt abgestimmt.',
          author: 'Martin & Erika H.',
          role: 'Hochzeitstag-Feier',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      items: [
        {
          question: 'Kann ich online reservieren?',
          answer:
            'Ja – oder telefonisch. Reservationstool kann ergänzt werden.',
        },
        {
          question: 'Gibt es vegetarische und vegane Optionen?',
          answer: 'Ja, wir bieten immer mindestens ein vegetarisches Hauptgericht an. Vegane Optionen sind auf Anfrage ebenfalls möglich — sprechen Sie uns bei der Reservation an.',
        },
        {
          question: 'Kann ich bei Ihnen einen privaten Anlass buchen?',
          answer: 'Ja, wir bieten Räumlichkeiten für private Feiern und Firmenanlässe bis 80 Personen. Wir erstellen Ihnen gerne ein individuelles Menü und Angebot.',
        },
      ],
    },
    cta: {
      title: 'Tisch reservieren',
      subtitle: 'Wir freuen uns auf Ihren Besuch.',
      email: 'reservation@example.ch',
    },
    footer: {
      companyName: 'Restaurant Muster',
      tagline: 'Saisonale Küche in Ihrer Region.',
      email: 'reservation@example.ch',
    },
  },
});
